export default __webpack_public_path__ + "static/media/register2.377a58a7.jpg";